import React from 'react';

const HomeCharactersTransition = () => {
  return (
    <div className="transition-main-container">
      <h1>Meet the Characters</h1>
    </div>
  )
}

export default HomeCharactersTransition;